import React from "react";
import {useNavigate} from "react-router-dom";
import {Box, Grid} from "@mui/material";

export const MainMenu = () => {

  const navigate = useNavigate()

  const goAddRoute = () => {
    navigate("/add")
  }

  const goMain = () => {
    navigate("/")
  }

  const goAvailabilityRoute = () => {
    navigate("/availability")
  }

  const goBalanceRoute = () => {
    navigate("/balance")
  }

  const goDeliveryOrdersRoute = () => {
    navigate("/delivery-orders")
  }

  return <Box component="form" sx={{ maxWidth: 600, margin: 'auto', padding: 2, bgColor: "fff" }}>
    <Grid container spacing={2}>
      <div className="flex gap-2">
        <button type="button" onClick={goMain}>Список моих кладов</button>
        <button type="button" onClick={goAddRoute}>Добавить клад</button>
        <button type="button" onClick={goAvailabilityRoute}>Мое Наличие</button>
        <button type="button" onClick={goBalanceRoute}>Мой Баланс</button>
        <button type="button" onClick={goDeliveryOrdersRoute}>Мои Заказы под адрес</button>
      </div>
    </Grid>
  </Box>
}
